<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/configuration/offers'">Offers</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      <span class="fs-5 fw-bold mb-0">{{ offer }}</span>
    </li>
  </ol>
</nav>

@if (offer) {
  <ul class="nav nav-tabs mb-3" role="tablist">
    <li class="nav-item" role="presentation">
      <a class="nav-link text-primary fw-bold" [routerLink]="['/configuration/offers', offer.id]" routerLinkActive="active"
      [routerLinkActiveOptions]="{exact:true}">Offer</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link text-primary fw-bold" [routerLink]="['/configuration/offers', offer.id, 'goals']"
      routerLinkActive="active">Goals</a>
    </li>
  </ul>
}

<div class="tab-content">
  <router-outlet></router-outlet>
</div>
